
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 3.333C14 2.598 13.402 2 12.667 2H3.333C2.598 2 2 2.598 2 3.333v9.334C2 13.402 2.598 14 3.333 14h9.334c.735 0 1.333-.598 1.333-1.333V3.333zM3.333 12.667V3.333h9.334l.001 9.334H3.333z","fill":"#7E8186"}}),_c('path',{attrs:{"d":"M4.667 4.667h1.332V6H4.667V4.667zm2.666 0h4V6h-4V4.667zM4.667 7.333h1.332v1.334H4.667V7.333zm2.666 0h4v1.334h-4V7.333zM4.667 10h1.332v1.333H4.667V10zm2.666 0h4v1.333h-4V10z","fill":"#7E8186"}})])
          )
        }
      }
    